import type {IRole} from "@models/roles/roles.js";
import {
    DefaultConsumerPesquisaAutoProps,
    DefaultPesquisaAuto,
} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {__roles_endpoints} from "@components/roles/endpoints/__roles_endpoints.ts";
import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";

interface RolesPesquisaProps extends DefaultConsumerPesquisaAutoProps<IRole, IGetRolesFilter> {
}

export function RolesPesquisa(props: RolesPesquisaProps) {
    const handleItemSelected = (item?: IRole) => {
        if (props.onItemSelected) {
            props.onItemSelected(item);
        }
    };

    const formataRole = (role: IRole) => `${role.id} - ${role.nome}`;

    return (
        <DefaultPesquisaAuto<IRole, IGetRolesFilter>
            endpoint={__roles_endpoints.v2['get-roles']} // Pass the API function
            searchField={'nome'}
            display={{
                name: 'Roles/Grupos'
            }}
            itemToString={formataRole}   // Pass the formatting function
            onItemSelected={handleItemSelected} // Pass the selection handler
            {...props}
        />
    );
}
